import { Box, Typography, withStyles } from '@material-ui/core';
import React from 'react';

const CustomBox = withStyles({
  root: {
    borderTop: '1px solid #e0e0e0',
    marginTop: 24,
    paddingTop: 20,
    textAlign: 'left',

    '& ul': {
      margin: '4px 0 0',
      paddingLeft: 22,
    },
    '& li': {
      fontSize: 14,
      color: '#333333',
      fontFamily: 'OpenSans',
      lineHeight: 1.6,
    },
  },
})(Box);

const SectionTitle = withStyles({
  root: {
    fontWeight: 600,
    fontSize: 18,
    color: '#333333',
    marginBottom: 8,
  },
})(Typography);

const SubTitle = withStyles({
  root: {
    fontWeight: 600,
    fontSize: 14,
    color: '#333333',
    marginTop: 16,
  },
})(Typography);

const BodyText = withStyles({
  root: {
    fontSize: 14,
    color: '#333333',
    fontFamily: 'OpenSans',
    lineHeight: 1.6,
  },
})(Typography);

const ELIGIBILITY = [
  'Children aged 18 and below',
  'Seniors aged 65 and above',
  'Public Assistance (PA) cardholders',
  'Pioneer Generation (PG) / Merdeka Generation (MG)',
  'CHAS Blue or Orange cardholders',
  'Medical Fee Exemption Card (MFEC) holders',
];

/** The amount is emphasised on its own, the way the design shows it. */
const SUBSIDISED_FEES = [
  { amount: '$0', description: 'PA cardholders' },
  { amount: 'Up to $5', description: 'PG / MG cardholders' },
  { amount: 'Up to $10', description: 'Other eligible patients' },
];

/** Haze Subsidy Scheme notice shown on the Doxy symptoms step. Static copy. */
const HazeSubsidyScheme = () => (
  <CustomBox>
    <SectionTitle>Haze Subsidy Scheme (HSS)</SectionTitle>

    <BodyText>
      The HSS helps eligible Singapore Citizens receive subsidised treatment for
      haze-related conditions such as cough, breathing difficulties and eye
      irritation.
    </BodyText>

    <SubTitle>Who is eligible?</SubTitle>
    <ul>
      {ELIGIBILITY.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>

    <SubTitle>Subsidised fees:</SubTitle>
    <ul>
      {SUBSIDISED_FEES.map(({ amount, description }) => (
        <li key={amount}>
          <strong>{amount}</strong> &ndash; {description}
        </li>
      ))}
    </ul>

    <BodyText style={{ marginTop: 16 }}>
      Applicable to eligible Singapore Citizens seeking treatment for 6
      haze-related conditions at participating clinics.
    </BodyText>
  </CustomBox>
);

export default HazeSubsidyScheme;
